import { ExternalLink } from 'lucide-react';
import { Card } from './ui';
import { CompanionCrest } from './CompanionCrest';

/* Cross-sell card for HomeGrade Pro, our companion app. Always shown at the
   bottom of the Household tab — a quiet sibling-product mention. No price/
   discount; "See …" never "Get …" since we can't know if they already have it. */
export function CompanionCard() {
  return (
    <Card className="p-4 space-y-3">
      <h2 className="font-medium">Our companion app</h2>
      <div className="flex items-start gap-4">
        <CompanionCrest size={44} className="shrink-0 mt-0.5" />
        <div className="min-w-0">
          <h3 className="font-serif text-lg text-ink">HomeGrade Pro</h3>
          <p className="mt-1 text-sm text-soft max-w-xl">
            From the same team behind HomeScholar Pro. Homeschooling through the high-school years?
            HomeGrade Pro is our gradebook &amp; transcript registrar — the same private-by-household
            design you use here.
          </p>
          <a
            href="https://homegradepro.com/?ref=homescholar"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 inline-flex items-center gap-1.5 text-sm font-medium text-forest-700 hover:underline"
          >
            See HomeGrade Pro <ExternalLink size={13} />
          </a>
        </div>
      </div>
    </Card>
  );
}
